import React, { lazy, Suspense } from 'react';

import clientOnly from '../../../hoc/clientOnly';

const App = lazy(() => import(/* webpackChunkName: "Roi" */ './App'));

const Loader = props => (
  <Suspense fallback={null}>
    <App {...props} />
  </Suspense>
);

export default clientOnly(Loader);
